export enum DynamicServiceEndpointVERB {
GET,
POST,
PUT,
}
